module.exports = __webpack_public_path__ + "img/1.898f1036.png";